
export function clampNumber(value, min, max) {
  const number = Number(value);
  if (!Number.isFinite(number)) return min;
  return Math.min(max, Math.max(min, number));
}

export function isHttpsUrl(value) {
  try {
    return new URL(value).protocol === "https:";
  } catch {
    return false;
  }
}

export function fieldStyleFromGlobal(style = {}) {
  return {
    input_height: style.input_height ?? 52,
    input_background_color: style.input_background_color || "#ffffff",
    input_border_color: style.input_border_color || "#dedede",
    input_border_width: style.input_border_width ?? 1,
    input_focus_border_color: style.input_focus_border_color || "#111111",
    text_color: style.text_color || "#333333",
    label_color: style.label_color || "#666666",
    placeholder_color: style.placeholder_color || "#9ca3af",
    input_error_color: style.input_error_color || "#dc2626",
    input_border_radius: style.input_border_radius ?? 6,
  };
}
